import NoPermissionsPage from './noPermissions.view';

export default NoPermissionsPage;
